import { Component, inject, signal } from '@angular/core'
import { RouterOutlet } from '@angular/router'
import { MatIconRegistry } from '@angular/material/icon'
import { DomSanitizer } from '@angular/platform-browser'
import { ReferenceDataService } from './public/reference-data/reference-data.service'
import { UserService } from './public/user/service/user.service'
import { NavBarComponent } from './home/nav-bar.component'
import { GlobalSpinnerComponent } from './public/spinner/global-spinner.component'
import { ToastsComponent } from './public/toasts/toasts.component'
import { ServicePointGroupService } from './public/service-point-groups/service-point-group.service'
import { FilterService } from './shared/services/filter/filter.service'
import { ToastService } from './public/toasts/toasts.service'

const matIcons = [
  'add_circle',
  'bolt',
  'calendar_month',
  'close',
  'expand_more',
  'filter',
  'first_page',
  'last_page',
  'more_horizontal',
  'search',
  'sort_asc',
  'sort_desc',
]

// get user every five minutes to check if credentials have expired
const getUserIntervalSeconds = 5 * 60

@Component({
  selector: 'app-root',
  imports: [
    NavBarComponent,
    GlobalSpinnerComponent,
    RouterOutlet,
    ToastsComponent,
  ],
  template: `
    <div class="wrapper landing__pagedisplay">
      <div class="app__container">
        <nav-bar></nav-bar>
        <app-global-spinner />
        <router-outlet />
        <app-toasts aria-live="polite" aria-atomic="true" />
      </div>
    </div>
  `,
  styles: `
    .landing__pagedisplay {
      display: flex;
      flex-direction: column;
    }

    .landing__pagedisplay_header {
      display: grid;
      position: fixed;
      width: 100%;
      z-index: 1000;
      background-color: white;
    }

    .app__container {
      position: relative;
    }

    .scrolling-container {
      overflow-y: auto;
    }

    .app__inner__container {
      margin-top: 88px;
    }

    .nav-container {
      border-bottom: 1.5px solid #c6c6c6;
      padding: 0.5rem 0;
      box-shadow: 0 4px 5px rgba(0, 0, 0, 0.25);
      background: #ffffff;

      .maintenance_toast {
        position: fixed;
        color: #fff;
        padding: 1rem;
      }
    }

    ameren-footer {
      position: fixed;
      bottom: 0;
      width: 100%;
    }
  `,
})
export class AppComponent {
  private readonly userService = inject(UserService)
  private readonly filterService = inject(FilterService)
  private readonly referenceDataService = inject(ReferenceDataService)
  private readonly servicePointGroupService = inject(ServicePointGroupService)
  private readonly toastService = inject(ToastService)

  private readonly serviceInit = signal(false)

  private readonly getUser = () => {
    this.userService.getUser().subscribe({
      complete: () => {
        if (!this.serviceInit()) {
          this.serviceInit.set(true)
          this.initServices()
        }
      },
      error: err => {
        if (err.status !== 401) {
          this.toastService.showError(err)
        }
      },
    })
  }

  constructor(matIconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
    matIcons.forEach((name) =>
      matIconRegistry.addSvgIcon(name, sanitizer.bypassSecurityTrustResourceUrl(`assets/icon/${name}.svg`)),
    )

    this.getUser()
    window.setInterval(this.getUser, getUserIntervalSeconds * 1000)
  }

  private initServices() {
    this.referenceDataService.init()
    this.servicePointGroupService.get().subscribe(groups => {
      groups.forEach(group => {
        void this.filterService.importServicePointGroup(group)
      })
    })
  }
}
